<div class="content">
    <div class="header">
        <h2>Shop By Occasion</h2>
        <a routerLink="/search" aria-label="All Products">View All
            <mat-icon fontSet="material-symbols-outlined" inline>arrow_forward</mat-icon>

        </a>
    </div>

    <div class="categories">
        @for (c of categories; track $index) {
        <a class="category" showdown [showDelay]="50+100*$index" routerLink="/search"
            [queryParams]="{category_ids:[c.id]}" aria-label="{{c.name}} Products">
            <h3>{{c.name}}</h3>

            <img [ngSrc]="c.icon|fileurl" fill [alt]="c.name + ' lace clothing category'">
        </a>
        }
    </div>
</div>
